import { render, staticRenderFns } from "./AddressEdit.vue?vue&type=template&id=6572acbe&scoped=true&"
import script from "./AddressEdit.vue?vue&type=script&lang=js&"
export * from "./AddressEdit.vue?vue&type=script&lang=js&"
import style0 from "./AddressEdit.vue?vue&type=style&index=0&id=6572acbe&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6572acbe",
  null
  
)

export default component.exports